import { createSelector } from '@reduxjs/toolkit';

import { name, TasksState } from '../reducers/tasks';
import { IDatedTask } from 'types/types';

export const getTasksSlice = (state): TasksState => state[name];

export const isLoadingActiveTaskSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isLoadingActiveTask
);

export const isCreatingNewTaskSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isCreatingNewTask
);

export const isUpdatingActiveTaskSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isUpdatingActiveTask
);

export const isOpenedActiveTaskSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isOpenedActiveTask
);

export const activeTaskSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.activeTask
);

export const activeTaskInfoSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.activeTask.taskInfo
);

export const prevActiveTaskIdSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.prevActiveTaskId
);

export const activeTaskIdSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask?.taskInfo?.id
);

export const activeTaskAttachmentsSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask?.taskInfo?.attachments
);

export const tasksSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.tasks
);

// селектор задач с заполненными полями startedAt и endedAt для календаря
export const datedTasksSelector = createSelector([getTasksSlice], tasks =>
  tasks.tasks.filter(
    (task): task is IDatedTask =>
      task.startedAt !== null && task.endedAt !== null
  )
);

export const tasksListMetaSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.tasksListMeta
);

export const taskLogsListMetaSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.logsListMeta
);

export const taskCommentsListMetaSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.commentsListMeta
);

export const isTasksNextPageLoadingSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isNextPageLoading
);

export const tasksFiltersSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.filters
);

export const prevTasksFiltersSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.prevFilters
);

export const isLoadingTasksListSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isFirstTimeLoading
);

export const isShownCreateNewTaskPopupSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isShownCreateNewTaskPopup
);

export const isTaskLogsLoadingSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.isTaskLogsLoading
);

export const taskLogsSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.logsList
);

export const taskCommentsSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.commentsList
);

export const taskCommentBodySelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.commentBody
);

export const isTaskCommentsLoadingSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.isTaskCommentsLoading
);

export const isSendingTaskCommentSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.isSendingTaskComment
);

export const isNextCommentsPageLoadingSelector = createSelector(
  [activeTaskSelector],
  activeTask => activeTask.isNextCommentsPageLoading
);

export const taskRelationsByTypeSelector = type =>
  createSelector(
    [activeTaskInfoSelector],
    activeTask =>
      activeTask?.relations?.filter(relation => relation.type === type) || []
  );

export const tasksCountSelector = createSelector(
  [tasksSelector],
  tasks => tasks.length
);

export const tasksTemplatesSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.templates
);

export const viewSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.view
);

export const selectedDateSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.selectedDate
);

export const isLoadingEntitiesSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.isLoadingEntities
);

export const taskEntitiesSearchResultsSelector = createSelector(
  [getTasksSlice],
  tasks => tasks.entitiesSearchResults
);
